import React from 'react'
import Header from '../common/Header.js'
import InnerBanner from '../common/InnerBanner.js'
import Footer from '../common/Footer.js'

const Terms = () => {
  return (
    <>
      <Header />

      <InnerBanner title="Terms of Service" />

      <div className="w3l-faq-main">
        <div className="faq-sec sec-padding">
          <div className="wrapper">
            <div className="faq-cont">
              <div className="about-right-faq">

                <div className="bg-warning text-dark p-3">
                  <b>Important:</b> Please read these Terms of Service,
                  the Privacy Policy and the applicable DLMP21 program,
                  purchase and reward rules carefully before using the
                  website/app or participating in the DLMP21 network.
                </div>

                <p className="all-terms mt-4">
                  Welcome to DLMP21. These Terms of Service govern your use
                  of the DLMP21 website, application, services and related
                  customer and business-partner facilities.
                </p>

                <p className="all-terms">
                  By registering for an account, accessing the platform,
                  purchasing through participating businesses, or otherwise
                  using DLMP21 services, you agree to comply with these Terms
                  of Service and any applicable policies, rules and notices
                  published by DLMP21 from time to time.
                </p>

                <p className="all-terms">
                  DLMP21 may update these Terms of Service from time to time.
                  Updated terms will apply from the effective date stated
                  on the website/app or from the date of publication where
                  no separate effective date is stated. Continued use of
                  the services after an update constitutes acceptance of
                  the revised terms.
                </p>


                {/* GENERAL */}
                <br />

                <h4 className="head-terms">
                  <b>1. GENERAL</b>
                </h4>

                <p className="all-terms">
                  <b>a)</b> "DLMP21", "we", "us" or "our" refers to the
                  DLMP21 service operated by Dreams Linkage Marketing Pro 21
                  (I)(OPC) PVT. LTD. "Customer", "User" or "you" refers to
                  any person who accesses, registers with or uses the
                  DLMP21 platform.
                </p>

                <p className="all-terms">
                  <b>b)</b> Participating businesses, franchisees, suppliers,
                  sponsors and other approved commercial parties may be
                  referred to as "Business Partners" where applicable.
                </p>

                <p className="all-terms">
                  <b>c)</b> To register and participate in DLMP21, you must
                  be at least 18 years of age unless otherwise permitted by
                  applicable law and DLMP21 policy.
                </p>

                <p className="all-terms">
                  <b>d)</b> You are responsible for providing accurate,
                  complete and current information during registration and
                  for keeping your account information up to date.
                </p>

                <p className="all-terms">
                  <b>e)</b> DLMP21 may refuse, suspend or terminate an
                  account where it reasonably believes that the user has
                  violated these terms, applicable rules, law, or platform
                  security requirements.
                </p>

                <p className="all-terms">
                  <b>f)</b> DLMP21 operates from Nagpur, Maharashtra, India,
                  and the services are intended to operate in accordance
                  with applicable Indian laws.
                </p>


                {/* USE OF SITE */}
                <br />

                <h4 className="head-terms">
                  <b>2. USE OF THE WEBSITE / APP</b>
                </h4>

                <p className="all-terms">
                  DLMP21 grants you a limited, personal, revocable and
                  non-exclusive right to access and use the website/app for
                  lawful purposes and in accordance with these Terms.
                </p>

                <p className="all-terms">
                  You must not misuse the platform, attempt unauthorized
                  access, interfere with its operation, introduce malicious
                  software, scrape or extract data through automated tools,
                  copy protected content for commercial purposes, or use
                  DLMP21 branding, trademarks, graphics or other proprietary
                  material without written permission.
                </p>


                {/* ACCOUNT */}
                <br />

                <h4 className="head-terms">
                  <b>3. CUSTOMER ACCOUNT AND DLMP CODE</b>
                </h4>

                <p className="all-terms">
                  Each registered customer may be provided with a unique
                  account and DLMP Code. The customer is responsible for
                  keeping account credentials and the DLMP Code secure and
                  must not knowingly allow another person to misuse the
                  account.
                </p>

                <p className="all-terms">
                  Information recorded against a customer account must be
                  accurate. DLMP21 may request verification or supporting
                  information where necessary for account, purchase or
                  reward processing.
                </p>


                {/* PURCHASE */}
                <br />

                <h4 className="head-terms">
                  <b>4. PURCHASES THROUGH PARTICIPATING BUSINESSES</b>
                </h4>

                <p className="all-terms">
                  DLMP21 may provide information about participating
                  businesses, products, services, offers and other local
                  commercial activities. Availability, pricing, product
                  quality, stock and fulfilment may depend on the respective
                  participating business.
                </p>

                <p className="all-terms">
                  Where an eligible purchase is required under the applicable
                  DLMP21 program rules, the purchase must satisfy the
                  conditions specified by DLMP21 for that program or reward
                  period.
                </p>

                <p className="all-terms">
                  Customers are responsible for checking the details of a
                  product, service, price and applicable business terms before
                  completing a purchase.
                </p>


                {/* PURCHASE RECORDING */}
                <br />

                <h4 className="head-terms">
                  <b>5. PURCHASE RECORDING</b>
                </h4>

                <p className="all-terms">
                  Where applicable, customers may be required to provide
                  their DLMP Code to the participating business after an
                  eligible purchase so that the transaction can be recorded
                  on the DLMP21 platform.
                </p>

                <p className="all-terms">
                  A transaction will only be treated as an eligible purchase
                  or qualifying activity where it satisfies the applicable
                  DLMP21 program rules, verification requirements and other
                  conditions in force at that time.
                </p>


                {/* REWARD NETWORK */}
                <br />

                <h4 className="head-terms">
                  <b>6. CUSTOMER NETWORK AND REWARDS</b>
                </h4>

                <p className="all-terms">
                  DLMP21 may provide a structured customer network that can
                  extend across multiple levels, subject to the applicable
                  program structure.
                </p>

                <p className="all-terms">
                  Applicable rewards, commissions or other benefits are
                  determined according to the relevant DLMP21 reward rules,
                  eligible purchase activity, network conditions,
                  verification and other applicable requirements.
                </p>

                <p className="all-terms">
                  Participation in the DLMP21 platform does not guarantee any
                  particular reward, commission, income or financial return.
                  Actual eligibility and amounts, where applicable, may vary
                  according to the program rules and qualifying activity.
                </p>

                <p className="all-terms">
                  DLMP21 reserves the right to correct, withhold, reverse or
                  adjust an incorrectly recorded reward or transaction where
                  permitted by the applicable rules, including cases
                  involving duplicate, invalid, fraudulent or reversed
                  transactions.
                </p>


                {/* BUSINESS PARTNERS */}
                <br />

                <h4 className="head-terms">
                  <b>7. PARTICIPATING BUSINESSES / BUSINESS PARTNERS</b>
                </h4>

                <p className="all-terms">
                  Participating businesses are responsible for the products
                  and services they provide to customers and for following
                  the applicable DLMP21 business-partner requirements.
                </p>

                <p className="all-terms">
                  DLMP21 may suspend or remove a participating business from
                  the platform where required because of policy violations,
                  verification issues, fraud, non-compliance or other
                  legitimate operational reasons.
                </p>


                {/* PRICES / OFFERS */}
                <br />

                <h4 className="head-terms">
                  <b>8. OFFERS, PRICES AND AVAILABILITY</b>
                </h4>

                <p className="all-terms">
                  Offers, promotional prices, availability and other business
                  information displayed through DLMP21 may change without
                  prior notice and remain subject to availability.
                </p>

                <p className="all-terms">
                  DLMP21 attempts to present accurate information but does
                  not guarantee that every listing, price, image,
                  specification or offer is error-free or continuously
                  available.
                </p>

                <p className="all-terms">
                  Where a product or service is provided by a participating
                  business, the relevant business may have additional terms
                  relating to payment, delivery, cancellation, replacement,
                  refund or warranty.
                </p>


                {/* CONTENT */}
                <br />

                <h4 className="head-terms">
                  <b>9. PROPRIETARY RIGHTS</b>
                </h4>

                <p className="all-terms">
                  Content made available through DLMP21, including text,
                  graphics, logos, icons, images, software, layouts, data
                  compilations and other materials, may be owned by DLMP21,
                  its licensors or participating Business Partners and may
                  be protected by applicable intellectual-property laws.
                </p>

                <p className="all-terms">
                  No licence or ownership right is granted to you except as
                  expressly stated in these Terms. You may not reproduce,
                  modify, distribute, sell or commercially exploit protected
                  DLMP21 content without prior written authorization.
                </p>


                {/* PRIVACY */}
                <br />

                <h4 className="head-terms">
                  <b>10. PRIVACY AND PERSONAL DATA</b>
                </h4>

                <p className="all-terms">
                  DLMP21 may collect and process information necessary to
                  provide its services, operate accounts, record eligible
                  transactions, communicate with users, maintain security and
                  perform other lawful business purposes.
                </p>

                <p className="all-terms">
                  Please refer to the DLMP21 Privacy Policy for details about
                  the categories of personal information collected, purposes
                  of processing, retention, security practices and available
                  user rights.
                </p>


                {/* REVIEWS */}
                <br />

                <h4 className="head-terms">
                  <b>11. REVIEWS, FEEDBACK AND SUBMISSIONS</b>
                </h4>

                <p className="all-terms">
                  Any reviews, comments, suggestions, ideas or other
                  submissions provided through the website/app may be used by
                  DLMP21 for service improvement, communication, moderation
                  and other lawful business purposes, subject to applicable
                  law and the Privacy Policy.
                </p>

                <p className="all-terms">
                  Users must not submit content that is unlawful, misleading,
                  defamatory, abusive, threatening, obscene, fraudulent,
                  infringing or harmful to another person or entity.
                </p>

                <p className="all-terms">
                  Users must not impersonate another person or entity or use
                  false information for the purpose of misleading others.
                </p>


                {/* AVAILABILITY */}
                <br />

                <h4 className="head-terms">
                  <b>12. SERVICE AVAILABILITY</b>
                </h4>

                <p className="all-terms">
                  DLMP21 will make reasonable efforts to keep its services
                  available but does not guarantee uninterrupted or
                  error-free operation.
                </p>

                <p className="all-terms">
                  Service availability may be affected by maintenance,
                  upgrades, telecommunications failures, third-party
                  services, security incidents, force majeure events or
                  circumstances beyond DLMP21's reasonable control.
                </p>


                {/* SUSPENSION */}
                <br />

                <h4 className="head-terms">
                  <b>13. SUSPENSION AND TERMINATION</b>
                </h4>

                <p className="all-terms">
                  DLMP21 may restrict, suspend or terminate access to an
                  account or service where necessary to protect the platform,
                  other users, Business Partners or DLMP21's legitimate
                  interests, or where the user breaches applicable terms,
                  rules or law.
                </p>

                <p className="all-terms">
                  Where an account is suspended or terminated, applicable
                  transaction, purchase and reward rules will continue to
                  apply to the extent required.
                </p>


                {/* INDEMNITY */}
                <br />

                <h4 className="head-terms">
                  <b>14. INDEMNITY</b>
                </h4>

                <p className="all-terms">
                  To the extent permitted by applicable law, you agree to
                  indemnify and hold harmless Dreams Linkage Marketing Pro 21
                  (I)(OPC) PVT. LTD., its directors, employees, officers,
                  agents and authorized representatives from claims, losses,
                  liabilities, costs and expenses arising from your unlawful
                  use of the platform, violation of these Terms, infringement
                  of third-party rights or misuse of the services.
                </p>


                {/* SEVERABILITY */}
                <br />

                <h4 className="head-terms">
                  <b>15. SEVERABILITY</b>
                </h4>

                <p className="all-terms">
                  If any provision of these Terms is found to be unlawful,
                  invalid or unenforceable by a competent authority, the
                  remaining provisions will continue to remain effective to
                  the extent permitted by law.
                </p>


                {/* GOVERNING LAW */}
                <br />

                <h4 className="head-terms">
                  <b>16. GOVERNING LAW</b>
                </h4>

                <p className="all-terms">
                  These Terms are intended to be governed by and interpreted
                  in accordance with applicable laws of India, subject to
                  applicable statutory rights and remedies.
                </p>


                {/* CHANGES */}
                <br />

                <h4 className="head-terms">
                  <b>17. CHANGES TO THE TERMS</b>
                </h4>

                <p className="all-terms">
                  DLMP21 may revise these Terms of Service, program rules,
                  reward rules, platform policies or other applicable
                  conditions from time to time. Users should review the
                  latest version before using the services.
                </p>


                {/* CUSTOMER SERVICE */}
                <br />

                <h4 className="head-terms">
                  <b>18. CUSTOMER SERVICE</b>
                </h4>

                <p className="all-terms">
                  Customer Care: +91 8856819762
                </p>

                <p className="all-terms">
                  Email: support@dlmp21.in
                </p>

                <p className="all-terms mt-4">
                  <b>Last Updated:</b> September 2026
                </p>

              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  )
}

export default Terms